import { IShipperRateSourceStatusEnum } from 'types/graphqlTypes'
import { TAG_STYLE } from 'transfix-ui'

export const JOB_STATUS_LABELS: Record<IShipperRateSourceStatusEnum, string> = {
  [IShipperRateSourceStatusEnum.cancelled]: 'Cancelled',
  [IShipperRateSourceStatusEnum.deving]: 'Deving',
  [IShipperRateSourceStatusEnum.done]: 'Done',
  [IShipperRateSourceStatusEnum.pending_volume]: 'Pending Volume',
  [IShipperRateSourceStatusEnum.redev]: 'Redev',
}

export const JOB_STATUS_STYLES: Record<IShipperRateSourceStatusEnum, TAG_STYLE> = {
  [IShipperRateSourceStatusEnum.cancelled]: TAG_STYLE.info,
  [IShipperRateSourceStatusEnum.deving]: TAG_STYLE.info,
  [IShipperRateSourceStatusEnum.done]: TAG_STYLE.success,
  [IShipperRateSourceStatusEnum.pending_volume]: TAG_STYLE.info,
  [IShipperRateSourceStatusEnum.redev]: TAG_STYLE.info,
}

export type TJobStatusLabels = typeof JOB_STATUS_LABELS
export type TJobStatusStyles = typeof JOB_STATUS_STYLES
